/*
 *
 * Attendance reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_ATTENDANCE,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
  /* DELETE_ATTENDANCE,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_ERROR, */
} from './constants';

export const initialState = {
  firstRender: true,
  loadingCourse: false,
  loading: false,
  loadingUpdates: false,
  errorCourse: false,
  error: false,
  courseDetail: false,
  itemsList: [],
  options: false,
  courseID: null,
};

/* eslint-disable default-case, no-param-reassign */
const attendanceReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ATTENDANCE:
        return initialState;

      case LOAD_COURSE:
        draft.loadingCourse = true;
        draft.errorCourse = false;
        draft.courseID = action.courseID;
        break;

      case LOAD_COURSE_SUCCESS:
        draft.loadingCourse = false;
        draft.courseDetail = action.courseDetail;
        break;

      case LOAD_COURSE_ERROR:
        draft.errorCourse = action.errorCourse;
        draft.loadingCourse = false;
        break;
      
      
      case LOAD_COURSES:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = [];
        draft.options = action.options;
        break;

      case LOAD_COURSES_SUCCESS:
        draft.loading = false;
        draft.itemsList = action.itemsList;
        break;

      case LOAD_COURSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.itemsList = [];
        draft.options = false;
        break;

      // Update for Single Element
      case UPDATE_COURSE:
        draft.firstRender = false;
        draft.loadingUpdates = false;
        draft.error = false;
        draft.courseDetail = action.courseDetail;
        break;

      case UPDATE_COURSE_SUCCESS:
        draft.loadingUpdates = false;
        const { courseDetail } = action;
        draft.courseDetail = courseDetail;
        let listData = draft.itemsList.data;
        let index = draft.itemsList.data.findIndex(
          po => po._id === courseDetail._id,
        );
        index !== -1
          ? (listData[index] = courseDetail)
          : listData.unshift(courseDetail);
        draft.itemsList = { ...draft.itemsList, data: listData };
        break;

      case UPDATE_COURSE_ERROR:
        draft.error = action.error;
        draft.loadingUpdates = false;
        break;

    /*  case CHANGE_ATTENDANCE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_ATTENDANCE:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_ATTENDANCE_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break; */
    }
  });

export default attendanceReducer;
